import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';

import { SharedModule } from '../../shared/shared.module';
import { GraphComponentsModule } from '../../graphs/graph-components.module';
import { BehaviorBipInfoComponent } from '../../supervisor/behaviors/behavior-bip-info/behavior-bip-info.component';
import { TargetNoteThreadComponent } from '../../shared/components/target-note-thread/target-note-thread.component';
import { TargetSelectorComponent } from './target-selector/target-selector.component';
import { TargetDetailsComponent } from './target-details/target-details.component';
import { TargetInfoComponent } from './target-info/target-info.component';
import { BoxFrequencyComponent } from './box-frequency/box-frequency.component';
import { BoxDurationComponent } from './box-duration/box-duration.component';
import { BoxDttComponent } from './box-dtt/box-dtt.component';
import { BoxQuantityComponent } from './box-quantity/box-quantity.component';
import { BoxFluencyrateComponent } from './box-fluencyrate/box-fluencyrate.component';
import { BoxRateComponent } from './box-rate/box-rate.component';
import { BoxAnecdotalComponent } from './box-anecdotal/box-anecdotal.component';
import { BoxEchoicComponent } from './box-echoic/box-echoic.component';
import { BoxGroupedComponent } from './box-grouped-frequency/box-grouped.component';
import { BoxIntervalComponent } from './box-interval/box-interval.component';
import { BoxToiletingComponent } from './box-toleting/box-toileting.component';
import { BoxTargetIntensityComponent } from './box-target-intensity/box-target-intensity.component';
import { BoxCurrencyComponent } from './box-currency/box-currency.component';

import { BoxBehaviorFrequencyComponent } from './box-behavior-frequency/box-behavior-frequency.component';
import { ABCDataPanelComponent } from './abc-data-panel/abc-data-panel.component';
import { BoxBehaviorDurationComponent } from './box-behavior-duration/box-behavior-duration.component';
import { BoxBehaviorIntervalComponent } from './box-behavior-interval/box-behavior-interval.component';
import { BoxBehaviorRatetimerComponent } from './box-behavior-ratetimer/box-behavior-ratetimer.component';
import { BoxBehaviorIntensityComponent } from './box-behavior-intensity/box-behavior-intensity.component';
import { SessionComponent } from '../sessions/session/session.component';
import { MatTabsModule } from '@angular/material/tabs';

const components = [
  SessionComponent,
  BoxBehaviorFrequencyComponent,
  BoxBehaviorDurationComponent,
  BoxBehaviorIntervalComponent,
  BoxBehaviorRatetimerComponent,
  BoxBehaviorIntensityComponent,
  ABCDataPanelComponent,
  TargetSelectorComponent,
  TargetDetailsComponent,
  TargetInfoComponent,
  BoxFrequencyComponent,
  BoxDurationComponent,
  BoxDttComponent,
  BoxQuantityComponent,
  BoxFluencyrateComponent,
  BoxRateComponent,
  BoxAnecdotalComponent,
  BoxEchoicComponent,
  BoxGroupedComponent,
  BoxIntervalComponent,
  BoxToiletingComponent,
  BoxTargetIntensityComponent,
  BoxCurrencyComponent,
];

@NgModule({
  imports: [
    CommonModule,
    MatTabsModule,
    FormsModule,
    SharedModule,
    GraphComponentsModule,
    InputNumberModule,
    BehaviorBipInfoComponent,
    TargetNoteThreadComponent,
  ],
  declarations: components,
  exports: components,
})
export class TargetBoxesModule {}
